module.exports = __webpack_public_path__ + "img/c02_unitfireship_Normal_ua.d2283d4e.webp";